module.exports = __webpack_public_path__ + "static/media/process1.b183cec9.jpeg";